import { render, staticRenderFns } from "./trailerCarousel.vue?vue&type=template&id=2731c06a&scoped=true&"
import script from "./trailerCarousel.vue?vue&type=script&lang=js&"
export * from "./trailerCarousel.vue?vue&type=script&lang=js&"
import style0 from "./trailerCarousel.vue?vue&type=style&index=0&id=2731c06a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2731c06a",
  null
  
)

export default component.exports